import { Box } from '@mui/material';
import { getCategoryColor, getImageURLCategoryListIcon } from '../utils/utils';
import { AppColor, Fonts } from '../types/Constants';
import { useAppSelector } from "../utils/hooks";
import ImageLoader from './ImageLoader';

type Props = {
    category?: string;
    fontSize?: string;
    padding?: string;
    minWidth?: string;
    borderRadius?: string;
    justifyContent?: string;
    id?: string;
    icons?: boolean;
    selected?: boolean;
    hover?: boolean;
    lastModfied?: string;
}

const BeaconCategory = ({ category, fontSize, padding, minWidth, borderRadius, justifyContent, id, icons = false, selected, hover = false, lastModfied }: Props) => {

    const categoryGroupState = useAppSelector((state) => state.category);

    const backgroundColor = category ? getCategoryColor(category, categoryGroupState.categories ?? []) : AppColor.componentBackground;

    const textColor = backgroundColor === "#ffffff" ? "silver" : "white";

    return (<Box
        sx={{
            color: textColor,
            backgroundColor: category ? getCategoryColor(category, categoryGroupState.categories ?? []) : AppColor.componentBackground,
            padding: padding ? padding : '0px 8px',
            border: selected ? "2px solid black" : "2px solid transparent",
            borderRadius: borderRadius ? borderRadius : '5px',
            minWidth: minWidth ? minWidth : "100px",
            display: 'flex',
            justifyContent: justifyContent ? justifyContent : "center",
            alignItems: "center",
            whiteSpace: 'nowrap',
            fontSize: fontSize ? fontSize : "14px",
            fontWeight: Fonts.MEDIUM,
            ...(hover && {
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.02)',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
                },
              }),
            paddingLeft: "4px"
        }}>
        {icons && (
            <ImageLoader 
                imageURL={getImageURLCategoryListIcon(id ?? "", lastModfied ?? "")}
                height="25px"
                width="25px"
                mr="6px"
                borderRadius='50%'
            />
        )}
        {category}
    </Box>
    );
};

export default BeaconCategory;
